<template>
  <div class="community-link " v-if="displayType">
    <community-type :community="community" />
    <h3 @click="goToCommunity" class="community-name">
      {{ community.name }}
    </h3>
  </div>
</template>

<script>
import CommunityType from '@/components/community/CommunityType'

export default {
  name: 'CommunityLink',
  components: { CommunityType },
  props: {
    community: {
      type: Object,
      required: true
    }
  },
  computed: {
    displayType() {
      return this.$store.getters.activeRoute.name !== 'communityPage'
    }
  },
  methods: {
    goToCommunity() {
      this.$router.push({ name: 'communityPage', params: { id: this.community.id } })
    }
  }
}
</script>

<style scoped lang="scss">
.community-link {
  display: flex;
  align-items: center;
  border-color: rgba(210, 179, 124, 0.2);
  border-width: 0 2px 2px 0;
  border-style: solid;
  border-radius: 0 0 0.6rem 0;
  cursor: pointer;
  &:hover{
    background-color: rgba(210, 179, 124, 0.04);
    border-color: rgba(210, 179, 124, 0.4);
  }
}

.community-name {
  font-size: 14px;
  padding: 0 0.5rem 0.3rem 0.5rem;

}
</style>
